const styles = {
  creatorsContainer:
    'content-box relative flex justify-center flex-wrap space-x-4',
};

export default styles;
